import React from 'react';
import { IconProps } from '../types/types';

const ADBE: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" role="img" {...props}><path fill="#ED1C24" d="M0 0h18v18H0z"/><path d="M7.676 4H4v10L7.676 4zm2.647 0H14v10L10.323 4zM9 7.667L7.382 12h1.765l.588 2h1.618L9 7.666z" fill="#fff"/></svg>
);

export default ADBE;